<style lang="scss">
    .basechannel .vview-formitem{
        margin-bottom:10px
    }
</style>
<template>
    <div>
        <!-- 调价 -->
        <vForm :model="formData" :label-width="150" class="margin-20 clearfix basechannel" ref="pricingform">
            <vCol span="12">
                <vFormItem v-if="alltype == 'query'" label='List Price'>
                    <span class="font-weight">{{formData.price}} </span>
                </vFormItem>
                <vFormItem v-else :label="'List Price'">
                    <div style="display:flex;">
                        <vInput v-model="formData.price" style="flex: 1;"></vInput>
                        <span style="flex: 0 50px;">&nbsp;&nbsp;{{compcurrency}}</span>
                    </div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem v-if="alltype == 'query'" label='Your Price'>
                    <span class="font-weight">{{formData.yourPrice}} </span>
                </vFormItem>
                <vFormItem v-else :label="'Your Price'">
                    <div style="display:flex;">
                        <vInput v-model="formData.yourPrice" style="flex: 1;"></vInput>
                        <span style="flex: 0 50px;">&nbsp;&nbsp;{{compcurrency}}</span>
                    </div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem v-if="alltype == 'query'" label='Sale Price'>
                    <span class="font-weight">{{formData.salePrice}} </span>
                </vFormItem>
                <vFormItem v-else :label="'Sale Price'">
                    <div style="display:flex;">
                        <vInput v-model="formData.salePrice" style="flex: 1;"></vInput>
                        <span style="flex: 0 50px;">&nbsp;&nbsp;{{compcurrency}}</span>
                    </div>
                    <span class="color-error">Promotion price</span>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem v-if="alltype == 'query'" label='Cost Price'>
                    <span class="font-weight">{{formData.costPrice}} </span>
                </vFormItem>
                <vFormItem v-else-if="alltype=='add'" :label="'Cost Price'">
                    <div style="display:flex;">
                        <vInput v-model="formData.costPrice" style="flex: 1;"></vInput>
                        <span style="flex: 0 50px;">&nbsp;&nbsp;{{compcurrency}}</span>
                    </div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem v-if="alltype == 'query'" label='Payment Price'>
                    <span class="font-weight">{{formData.paymentPrice}} </span>
                </vFormItem>
                <vFormItem v-else-if="alltype=='add'" :label="'Payment Price'">
                    <div style="display:flex;">
                        <vInput v-model="formData.paymentPrice" style="flex: 1;"></vInput>
                        <span style="flex: 0 50px;">&nbsp;&nbsp;{{compcurrency}}</span>
                    </div>
                </vFormItem>
            </vCol>
             <vCol span="12" v-if="otherType=='amazon' && alltype == 'query'">
                <vFormItem :label="$t('erp.channel.catch_price', { defaultValue: '抓取平台售价' })">
                    <span class="font-weight">{{formData.listingPrice}} </span>
                </vFormItem>

            </vCol>

             <vCol span="12" v-if="otherType=='amazon' && alltype == 'query'">
                <vFormItem :label="$t('erp.channel.newest_catch_time', { defaultValue: '平台售价的最新抓取时间' })">
                    <span class="font-weight">{{formData.listingPriceDate || '--'}} </span>
                </vFormItem>

            </vCol>

            <vCol span="24">
                <vFormItem  v-if="alltype == 'query'" :label="$t('erp.channel.start_high_price', { defaultValue: '启动高级定价' })">
                    <vCheckbox disabled v-model="formData.businessPriceFlag"></vCheckbox>
                </vFormItem>
                <vFormItem v-else :label="$t('erp.channel.start_high_price', { defaultValue: '启动高级定价' })">
                    <vCheckbox v-model="formData.businessPriceFlag" @on-change="changeShow(formData.businessPriceFlag)"></vCheckbox>
                </vFormItem>
            </vCol>
            <vCol span="12" v-if="showbox">
                <vFormItem v-if="alltype == 'query'" label="Business Price">
                    <div class="pull-left margin-right-5">{{formData.productChannelBusiness.businessPrice}} {{compcurrency}}</div>
                </vFormItem>
                <vFormItem v-else label="Business Price">
                    <vInput v-model="formData.productChannelBusiness.businessPrice" class="pull-left margin-right-5"></vInput>{{compcurrency}}
                </vFormItem>
            </vCol>
            <vCol span="12" v-if="showbox">
                <vFormItem v-if="alltype == 'query'" label="Business Price Type">
                    <RadioGroup disabled v-model="formData.productChannelBusiness.quantityPriceType" @on-change="changefixed">
                        <Radio label="percent"><span>{{$t('erp.channel_count_percent', { defaultValue: '优惠百分比' })}}</span></Radio>
                        <Radio label="fixed"><span>{{$t('erp.channel.new_price', { defaultValue: '新价格' })}}</span></Radio>
                    </RadioGroup>
                </vFormItem>
                <vFormItem v-else label="Business Price Type">
                    <RadioGroup v-model="formData.productChannelBusiness.quantityPriceType" @on-change="changefixed">
                        <Radio label="percent"><span>{{$t('erp.channel_count_percent', { defaultValue: '优惠百分比' })}}</span></Radio>
                        <Radio label="fixed"><span>{{$t('erp.channel.new_price', { defaultValue: '新价格' })}}</span></Radio>
                    </RadioGroup>
                </vFormItem>
            </vCol>

            <vCol span="24" v-if="showbox">
                <vFormItem label="Quantity Discount">
                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="formData.productChannelBusiness.quantityLowerBound1"></vInput></div>

                        <div class="margin-right-20" v-if="alltype=='query'" ><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="present1"></vInput></div>

                        <div class="margin-right-20" v-else><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInputNumber class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='fixed'" v-model="present1"></vInputNumber></div>

                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{compcurrency}})</span> <vInput class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='percent' || alltype=='query'" v-model="quantityPrice1"></vInput></div>
                    </div>

                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right"  :readonly="alltype=='query'" v-model="formData.productChannelBusiness.quantityLowerBound2"></vInput></div>

                        <div class="margin-right-20" v-if="alltype=='query'" ><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="present2"></vInput></div>
                        <div class="margin-right-20" v-else><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInputNumber class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='fixed'" v-model="present2"></vInputNumber></div>

                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{compcurrency}})</span> <vInput class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='percent' || alltype=='query'" v-model="quantityPrice2"></vInput></div>
                    </div>

                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right"
                        :readonly="alltype=='query'" v-model="formData.productChannelBusiness.quantityLowerBound3"></vInput></div>

                        <div class="margin-right-20" v-if="alltype=='query'" ><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="present3"></vInput></div>
                        <div class="margin-right-20" v-else><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInputNumber class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='fixed'" v-model="present3"></vInputNumber></div>

                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{compcurrency}})</span> <vInput class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='percent' || alltype=='query'" v-model="quantityPrice3"></vInput></div>
                    </div>

                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right"
                        :readonly="alltype=='query'" v-model="formData.productChannelBusiness.quantityLowerBound4"></vInput></div>

                        <div class="margin-right-20" v-if="alltype=='query'" ><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="present4"></vInput></div>
                        <div class="margin-right-20" v-else><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInputNumber class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='fixed'" v-model="present4"></vInputNumber></div>

                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{compcurrency}})</span> <vInput class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='percent' || alltype=='query'" v-model="quantityPrice4"></vInput></div>
                    </div>

                    <div style="display:flex" class="margin-bottom-10">
                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.number_gt', { defaultValue: '数量大于' })}}</span> <vInput class="pull-right"  :readonly="alltype=='query'" v-model="formData.productChannelBusiness.quantityLowerBound5"></vInput></div>

                        <div class="margin-right-20" v-if="alltype=='query'" ><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInput class="pull-right" :readonly="alltype=='query'" v-model="present5"></vInput></div>
                        <div class="margin-right-20" v-else><span class="margin-right-5">{{$t('erp.channel.preferential', { defaultValue: '优惠(%)' })}}</span> <vInputNumber class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='fixed'" v-model="present5"></vInputNumber></div>

                        <div class="margin-right-20"><span class="margin-right-5">{{$t('erp.channel.price', { defaultValue: '价格' })}}({{compcurrency}})</span> <vInput class="pull-right" :readonly="formData.productChannelBusiness.quantityPriceType=='percent' || alltype=='query'" v-model="quantityPrice5"></vInput></div>
                    </div>
                </vFormItem>
            </vCol>
        </vForm>
    </div>
</template>

<script>

export default {
    props:['alltype','pricedata','compcurrency','otherType'],
    data(){
        return {
            formData:{
                businessPriceFlag:false,
                productChannelBusiness:{
                    businessPrice:0,
                    quantityPriceType:'percent'
                },
            },
            present1:0,
            present2:0,
            present3:0,
            present4:0,
            present5:0,
            showbox:false,
            showcurrency:false,
        }
    },
    components:{

    },
    computed:{
        "quantityPrice1":{
            get: function () {
                let price = 0;
                if(this.formData.productChannelBusiness.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.productChannelBusiness.businessPrice * (1-(this.present1/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice2":{
            get: function () {
                let price = 0;
                if(this.formData.productChannelBusiness.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.productChannelBusiness.businessPrice * (1-(this.present2/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice3":{
            get: function () {
                let price = 0;
                if(this.formData.productChannelBusiness.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.productChannelBusiness.businessPrice * (1-(this.present3/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice4":{
            get: function () {
                let price = 0;
                if(this.formData.productChannelBusiness.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.productChannelBusiness.businessPrice * (1-(this.present4/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
        "quantityPrice5":{
            get: function () {
                let price = 0;
                if(this.formData.productChannelBusiness.quantityPriceType=='percent' && this.formData.businessPriceFlag == true){
                    price = this.formData.productChannelBusiness.businessPrice * (1-(this.present5/100))
                }
                return price.toFixed(2) || 0
            },
            set: function (value) {
                return value
            },
        },
    },
    methods:{
        handledata(){
            // console.log(this.pricedata,'ssssdsdsdsdsdsdsdsd')
            this.formData = this.pricedata



            if(this.formData.businessPriceFlag==true){
                if(this.pricedata.productChannelBusiness != null){
                    this.showbox = true
                    this.present1 = this.pricedata.productChannelBusiness.percent1;
                    this.present2 = this.pricedata.productChannelBusiness.percent2;
                    this.present3 = this.pricedata.productChannelBusiness.percent3;
                    this.present4 = this.pricedata.productChannelBusiness.percent4;
                    this.present5 = this.pricedata.productChannelBusiness.percent5;
                }
            }

        },
        changeShow(value){
            // console.log(value)
            let _this = this

            if(value == true){
                if(this.formData.productChannelBusiness == null){
                    this.formData.productChannelBusiness = {
                        businessPrice:0,
                        quantityPriceType:'percent'
                    }
                }
                this.showbox = true;
            }else{
                this.showbox = false;
            }
        },
        changefixed(){
            if(this.formData.productChannelBusiness.quantityPriceType == 'fixed'){
            // console.log(12345)
                this.present1 = 0;
                this.present2 = 0;
                this.present3 = 0;
                this.present4 = 0;
                this.present5 = 0;
            }else{
                // console.log(455454)
                this.quantityPrice1 = 0;
                this.quantityPrice2 = 0;
                this.quantityPrice3 = 0;
                this.quantityPrice4 = 0;
                this.quantityPrice5 = 0;
            }
        },
        cancel(){
            this.$emit('on-close')
        }
    },
    watch:{
        pricedata(){
            this.handledata()
        }
    }
}
</script>
